import React from 'react'

export default function LandscapeView() {
  return (
    <div className="landscape-container">
      <video width="200" autoPlay loop muted playsInline preload='auto'>
        <source src="assets/media/rotate.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <p>Vui lòng xoay thiết bị của bạn <br /> sang chế độ dọc.</p>
    </div>
  )
}
